import { createContext } from 'react';
import { IBeneMember } from '../types/Beneficiary';
import { ICaseInfo } from '../types/Case';

export interface IBeneDocAdditionalContext {
  passportDocTypeId?: number;
  otherDocTypeId?: number;
  beneId?: number;
  companyId?: number;
  caseId?: number;
  userId?: number;
  beneMembers: IBeneMember[];
  hasPassportItem?: boolean;
  caseInfo?: ICaseInfo;
  setContext?: (newContext: IBeneDocAdditionalContext) => void;
}

export const BeneDocAdditionalContext = createContext<IBeneDocAdditionalContext>({ beneMembers: [] });
